import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import { styled } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'
import { ExpandMore } from '@mui/icons-material'
import { Can } from '../../utils/AbilityUtil'
import { Rule, Section } from '../../models/Rule'
import { analyzeCodeAsync } from '../../services/rulesService'
import { setIsLoading } from '../../actions/files'
import { updateSelectedRule } from '../../actions/rule'

const StyledListItem = styled(ListItem)(({ theme }) => ({
  '&& .Mui-selected': {
    backgroundColor: '#06004A',
    '&, & .MuiListItemIcon-root': {
      color: 'white',
    },
  },
}))

const SectionList = () => {
  const dispatch = useDispatch<any>()
  const projectName = useSelector((state: RootState) => state.rule.projectName)
  const selectedChapter = useSelector(
    (state: RootState) => state.rule.selectedChapter,
  )

  const handleAnalyzeCode = (rule: Rule) => {
    const payload = {
      ruleId: rule.code_regulation_id,
      projectName: projectName!,
    }
    dispatch(updateSelectedRule(rule))
    dispatch(setIsLoading(true))
    dispatch(analyzeCodeAsync(payload))
  }

  return (
    <Can I={AttributeActionNames.Read} a={AttributeResourceNames.Clients}>
      <Box sx={{ width: '80%' }}>
        <List style={{ maxHeight: '65vh', overflowY: 'auto' }}>
          {selectedChapter?.sections?.map((section: Section, index: any) => (
            <StyledListItem key={index} disablePadding>
              <ListItemButton
                selected={section.name === selectedChapter?.name}
                style={{ margin: 0, padding: '5px 16px' }}
              >
                <Accordion
                  key={section.name}
                  slotProps={{ heading: { component: 'h6' } }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls='panel1-content'
                    id='panel1-header'
                  >
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                      }}
                    >
                      {section.name}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 1, gap: 3 }}>
                    {section.rules?.map((rule) => (
                      <Box
                        key={rule.code_regulation_id}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1,
                          mb: '15px',
                          color: '#737373',
                          p: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            alignContent: 'center',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'left',
                            color: 'black',
                          }}
                        >
                          {rule.code_regulation_name}
                        </Typography>
                        <Typography
                          sx={{
                            alignContent: 'center',
                            fontSize: '12px',
                            fontWeight: '500',
                            textAlign: 'left',
                          }}
                        >
                          {rule.content}
                        </Typography>
                        <Button
                          variant='contained'
                          onClick={() => handleAnalyzeCode(rule)}
                          sx={{
                            background: '#56003D',
                            color: 'white',
                            textTransform: 'capitalize',
                            width: '110px',
                            fontSize: '12px',
                            px: '12px',
                            '&:hover': {
                              backgroundColor: '#56003D',
                            },
                          }}
                        >
                          Analyze Code
                        </Button>
                      </Box>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </ListItemButton>
            </StyledListItem>
          ))}
        </List>
      </Box>
    </Can>
  )
}

export default SectionList
